export default __webpack_public_path__ + "static/media/3081915.60f2bee3.png";